<div class="entry-text" [ngStyle]="prefixStyles() | theme">
  {{ prefix() }}
</div>
<div class="amounts" [class.struck-fee]="struck()">
  @if (primary().icon && primary().iconPosition === "start") {
    <app-currency-icon [icon]="primary().icon!" sizeCss="--icon-small" />
  }
  <div class="entry-text" [ngStyle]="feeStyles() | theme">
    {{ primary().text }}
  </div>
  @if (primary().icon && primary().iconPosition === "end") {
    <app-currency-icon [icon]="primary().icon!" sizeCss="--icon-small" />
  }
  @if (shownSecondary(); as secondary) {
    <div class="secondary-span">
      <div class="entry-text" [ngStyle]="feeStyles() | theme">
        {{ "(" }}
      </div>
      <div class="secondary-icon-span">
        @if (secondary.icon && secondary.iconPosition === "start") {
          <app-currency-icon [icon]="secondary.icon!" sizeCss="--icon-small" />
        }
        <div class="entry-text" [ngStyle]="feeStyles() | theme">
          {{ secondary.text }}
        </div>
        @if (secondary.icon && secondary.iconPosition === "end") {
          <app-currency-icon [icon]="secondary.icon!" sizeCss="--icon-small" />
        }
      </div>
      <div class="entry-text" [ngStyle]="feeStyles() | theme">
        {{ ")" }}
      </div>
    </div>
  }
</div>
<ng-content />
